import styled from "styled-components";

export const BookingSearchFieldsContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${props => props.theme.spacing.spacing20};
`
